import type { NavigationState, PartialState } from '@react-navigation/native';
import { navigationRef } from '../../root-navigation';

interface RouteBranch {
  name: string;
  state?: NavigationState | PartialState<NavigationState>;
}

export function subscribeNavigationState(onStoreChange: () => void) {
  if (!navigationRef.isReady()) {
    return () => undefined;
  }
  return navigationRef.addListener('state', onStoreChange);
}

export function getCurrentRouteBranchKey() {
  if (!navigationRef.isReady()) {
    return '';
  }

  const routeNames: string[] = [];
  let state: NavigationState | PartialState<NavigationState> | undefined = navigationRef.getRootState();

  while (state?.routes.length) {
    const route: RouteBranch | undefined = state.routes[state.index ?? 0];
    if (!route) {
      break;
    }

    routeNames.push(route.name);
    state = route.state;
  }

  return routeNames.join('>');
}
